import React, { useLayoutEffect, useState } from 'react'

/**
 * Touch-sized popover triggered by an overflow (⋮) icon. Items render as
 * full-width tap targets; backdrop click dismisses.
 *
 * Items shape: `{ label, onClick, danger?: boolean, disabled?: boolean }`.
 * `danger` colours the row red (use for Block/Spam etc.).
 *
 * Position: anchored to a trigger DOM node via `anchorRef`. The popover
 * appears just below the trigger's bottom edge, right-aligned to the
 * trigger's right edge. This works on both phone and tablet regardless
 * of how much page chrome sits above — hard-coded screen coordinates
 * misaligned the popover relative to the conv header on tablet.
 */
function PhoneMenuPopover({ open, onClose, items, anchorRef }) {
  const [pos, setPos] = useState(null)

  // Measure synchronously before paint so the popover never flashes at
  // (0,0). Re-measure if `open` toggles or the ref changes.
  useLayoutEffect(() => {
    if (!open) {
      setPos(null)
      return
    }
    const el = anchorRef?.current
    if (!el) return
    const rect = el.getBoundingClientRect()
    setPos({
      top: rect.bottom + 4,
      right: Math.max(8, window.innerWidth - rect.right)
    })
  }, [open, anchorRef])

  if (!open || !pos) return null

  return (
    <div className="phmenu-backdrop" onClick={onClose}>
      <div
        className="phmenu"
        style={{ top: pos.top, right: pos.right }}
        onClick={e => e.stopPropagation()}
        role="menu"
      >
        {items.map((item, i) => (
          <button
            key={i}
            role="menuitem"
            className={`phmenu-item ${item.danger ? 'phmenu-item--danger' : ''}`}
            disabled={item.disabled}
            onClick={() => {
              onClose()
              item.onClick()
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default PhoneMenuPopover
